export default __webpack_public_path__ + "static/media/Gears.578bf50c.svg";